export default __webpack_public_path__ + "static/tires-two-f72752480e2725cfa3de827de168d2f8.svg";